import { type CommunityList, type Pagination, type PaginationData, createCommunityList } from 'models';
import { useQuery } from 'query';
import { getCommunities } from '../services';
import type { CommunityScope } from '../types';
import { getCommunitiesQueryKey } from './keys';

type P = {
  featured?: boolean;
  organizationId?: string;
  pagination?: Pagination;
  scope?: CommunityScope;
  search?: string;
};

export const useCommunitiesQuery = ({ featured, organizationId, pagination, scope, search }: P) =>
  useQuery<PaginationData<CommunityList>>({
    async queryFn() {
      const { pageSize, position } = pagination ?? {};

      const response = await getCommunities({
        config: {
          params: {
            featured,
            limit: pageSize,
            offset: position !== undefined && pageSize !== undefined ? position * pageSize : undefined,
            organization_id: organizationId,
            scope,
            search,
            view: 'table',
          },
        },
      });

      return {
        data: response.data.data.map((community) => createCommunityList(community)),
        total: response.data.total,
      };
    },
    queryKey: getCommunitiesQueryKey({ featured, organizationId, pagination, scope, search }),
  });
